export default __webpack_public_path__ + "static/media/register-background.73bd2fa1.jpg";